exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success p[data-v-fe85a2d2] {\n  color: #000;\n}\n.error[data-v-fe85a2d2] {\n  border-color: #ff0000;\n}", ""]);

// exports
